import React, { memo } from 'react';
import Skeleton from '@mui/material/Skeleton';
import { CellsProps } from './GridSkeleton.props';

const firstRowHeight = 50;
const rowHeight = 30;

const GridSkeletonCells = memo(({ row, maxColumns, classes }: CellsProps) => {
  const cols = [];

  for (let i = 0; i < maxColumns; i += 1) {
    cols.push(
      <Skeleton
        variant="rect"
        className={classes.cell}
        height={row === 0 ? firstRowHeight : rowHeight}
        key={`${row}-${i}`}
      />
    );
  }

  return <>{cols}</>;
});

export default GridSkeletonCells;
